import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {useQueryClient} from '@tanstack/react-query'
import React, {useEffect, useMemo, useRef} from 'react'
import {useParams} from 'react-router-dom/cjs/react-router-dom.min'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../query-manager/QueryKeyTypes'
import {checkEmptyString} from '../../utils/CommonUtils'
import {useAuth} from '../authentication/AuthProvider'
import {severityNotification} from '../notification/NotificationConstant'
import {showNotification} from '../notification/NotificationService'
import StyledDetailInformationSection from '../styled-component/information/StyledDetailInformationSection'
import {
    clientConfigurationInfoList,
    clientPatientConfigurationList,
} from './ClientConstants'
import {useClientCRUD} from './query-keys/ClientQueryManager'

const ClientConfiguration = ({data = {}}) => {
    useSignals()

    //#region Context
    const {translateCommons} = TranslateUtils
    const {user} = useAuth()
    //#endregion

    //#region Param
    const {id: idString} = useParams()
    const id = useMemo(() => {
        return !!idString ? parseInt(idString) : null
    }, [idString])
    //#endregion

    //#region Ref
    const sectionRef = useRef(null)
    const codeConfigRef = useRef({})
    //#endregion

    //#region State
    const formData = useSignal({})
    useEffect(() => {
        if (data) {
            formData.value = data
        }
    }, [data])
    //#endregion

    //#region Query
    const queryClient = useQueryClient()
    const {clientKeys} = QueryKeyManager(QueryKeyTypes.client, user?.id)

    const clientQueryKeys = useMemo(() => {
        return clientKeys.detail({id})
    }, [clientKeys, id])

    const {mutateAsync: createOrUpdateClient} = useClientCRUD(
        QueryCRUDTypes.update,
        user?.id,
    )
    //#endregion

    //#region Handle Function
    const handleOnsubmit = async submitData => {
        let toPostData = {
            ...formData.value,
            ...submitData,
        }
        if (
            !toPostData?.firstName ||
            toPostData?.firstName?.length < 0 ||
            !!checkEmptyString(toPostData?.firstName)
        ) {
            showNotification(
                severityNotification.error,
                'First Name is required !!',
            )
            return
        }

        const clientData = await createOrUpdateClient(toPostData)
        if (clientData?.id) {
            queryClient.setQueryData(clientQueryKeys, () => clientData)

            sectionRef.current?.onSuccess()
        }
    }

    return (
        <React.Fragment>
            {/* Patient Configuration */}
            <div className="col-12 p-0">
                <StyledDetailInformationSection
                    ref={sectionRef}
                    data={data}
                    dataList={clientConfigurationInfoList}
                    onSubmit={handleOnsubmit}
                />
                <StyledDetailInformationSection
                    ref={sectionRef}
                    data={data}
                    dataList={clientPatientConfigurationList}
                    onSubmit={handleOnsubmit}
                />
            </div>
        </React.Fragment>
    )
}

export default ClientConfiguration
